import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrl: './management.component.scss',
})
export class ManagementComponent {
  tabs = [
    { key: '1', text: 'Áreas y Cargos', route: 'areas' },
    { key: '2', text: 'Países y Ciudades', route: 'countries' },
  ];
  selectedTabKey: number = 1;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateSelectedTabKey(this.router.url);

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.updateSelectedTabKey(event.url);
      });
  }

  updateSelectedTabKey(url: string): void {
    const urlSegments = url.split('/');
    const currentRoute = urlSegments[urlSegments.length - 1];
    const previousRoute = urlSegments[urlSegments.length - 2];

    if (currentRoute === 'countries') {
      this.selectedTabKey = 2;
    } else if (currentRoute === 'areas') {
      this.selectedTabKey = 1;
    } else {
      this.selectedTabKey = 1;
    }
  }

  onTabSelected(index: number): void {
    const selectedTab = this.tabs[index];
    if (selectedTab) {
      this.selectedTabKey = Number(selectedTab.key);
      this.router.navigate([`/dashboard/management/${selectedTab.route}`]);
    }
  }
}
